import angular from 'angular';

import SEGMENT_EVENTS from 'constants/segmentEvents';

function Ctrl($rootScope, $scope, $state, $stateParams, $window, $http, utilsService, settingsService, loggerService, metaTagService, trackingService) {
  const isSignup = ($state.current.name === 'app.signup');

  const title = isSignup ? 'Sign Up | Tablelist' : 'Login | Tablelist';

  $scope.titleText = isSignup ? 'Sign up for Tablelist' : 'Log in to Tablelist';

  metaTagService.set({
    title: title,
    description: 'Sign up for Tablelist and get instant access to exclusive nightlife, VIP bottle service, table service and members-only events in Boston, NYC, Las Vegas and San Francisco',
    facebookImage: 'https://assets.tablelist.com/www-2/images/tablelist-header-image.jpg'
  });

  $scope.scrollTo = function(target) {
    utilsService.scrollTo(target, 110, 500);
  };

  let promoCode = $stateParams.code;

  try {
    if ($stateParams.redirectParams) {
      const redirectParams = angular.fromJson($stateParams.redirectParams);

      if (redirectParams.code) {
        promoCode = redirectParams.code;
      }
    }
  } catch (e) {} // eslint-disable-line no-empty

  if (promoCode) {
    checkPromo(promoCode, function(err, resp) {
      if (resp.referral) {

        $scope.promo = resp;

        metaTagService.set({
          title: 'Get credit towards your night out. Signup with my promo code.',
          description: `Tablelist is the easiest way to book VIP tables at the best nightclubs and lounges. Sign up with my code (${$scope.promo.code}) and get free credit!`,
          facebookTitle: 'Get credit towards your night out.',
          facebookDescription: `Join ${$scope.promo.name} on Tablelist and get access to best party and nightlife spots in your city.`
        });
      } else {
        $scope.promo = resp;
      }
    });
  }

  function checkPromo(promo, done) {
    if (!promo) {
      done('No Promo Provided', null);
    }

    const promise = $http.get(`/promo/check/${promo}`);

    promise.success(function(resp) {
      done(false, resp);
    });

    promise.error(function(resp) {
      done(resp, null);
    });
  }

  $scope.loginConfig = {
    title: title,
    promo: ($scope.promo && $scope.promo.code) ? $scope.promo.code : null,
    startState: isSignup ? 'newUser' : 'existingUser',
    success: function() {
      if (isSignup) {
        trackingService.trackEvent(SEGMENT_EVENTS.SignedUp);
      }

      if ($stateParams.redirectUrl) {
        $window.location = $stateParams.redirectUrl;
        return;
      }

      const redirectState = $stateParams.redirectState;
      let redirectParams = null;

      try {
        redirectParams = angular.fromJson($stateParams.redirectParams);
      } catch (e) {} // eslint-disable-line no-empty

      if (redirectState) {
        $state.transitionTo(redirectState, redirectParams);
      } else {
        $state.transitionTo('app.me.profile');
      }
    },
    error: function(response) {
      loggerService.error(response);
      $scope.errorMsg = utilsService.errorMessage(response);
    }
  };

  $scope.referralGiveCredit = 25;

  settingsService.config(function success(resp) {
    $scope.referralGiveCredit = resp.referralGiveCredit;
  });
}

Ctrl.$inject = [
  '$rootScope',
  '$scope',
  '$state',
  '$stateParams',
  '$window',
  'tl.http',
  'utilsService',
  'tl.settings.service',
  'loggerService',
  'metaTagService',
  'trackingService'
];

export default Ctrl;



// WEBPACK FOOTER //
// ./src/components/signup/signupCtrl.js